const neighborhoodHomepage = {
  displayField: 'title',
  name: 'Neighborhood Homepage',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'subtitle',
      name: 'Subtitle',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'neighborhood',
      name: 'Neighborhood',
      type: 'Link',
      localized: false,
      required: true,
      validations: [ { linkContentType: [ 'neighborhoodSingle' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'metaTitle',
      name: 'Meta Title',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'metaDescription',
      name: 'Meta Description',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'openGraphImage',
      name: 'Open Graph Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'schema',
      name: 'Schema',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'storyContentHeader',
      name: 'StoryContentHeader',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'storyContentBody',
      name: 'StoryContentBody',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'marketTrendHeader',
      name: 'MarketTrendHeader',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false
    },
    {
      id: 'marketTrendCustom',
      name: 'Market Trend Custom',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: null, max: 3 } } ],
      disabled: true,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'marketTrendDisclaimer',
      name: 'Market Trend Disclaimer',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false
    },
    {
      id: 'marketTrendCtaText',
      name: 'Market Trend CTA Text',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false
    },
    {
      id: 'marketTrendCtaFile',
      name: 'Market Trend CTA File',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'listingsHeader',
      name: 'ListingsHeader',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'mapHeader',
      name: 'MapHeader',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact',
      name: 'Contact Us Module',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'StackedTextImageForm' ] } ],
      disabled: true,
      omitted: true,
      linkType: 'Entry'
    },
    {
      id: 'dynamicContentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'wideTextImage',
              'wideTextImageWithForm',
              'StackedTextImageForm',
              'WideStackedTextImageBlock'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ],
      ContentTypeField: {
        seo: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'neighborhoodHomepage',
    version: 20,
    updatedAt: '2023-08-02T22:34:49.823Z'
  }
};
export default neighborhoodHomepage;